import type { DestinationAdapter, DestinationResult } from './types';
import type { DestinationLogger } from './DestinationLogger';

/**
 * Isolates destination failures so one adapter never brings down others.
 */
export class DestinationErrorHandler {
  private readonly logger: DestinationLogger;

  private readonly continueOnError: boolean;

  constructor(logger: DestinationLogger, continueOnError: boolean) {
    this.logger = logger;
    this.continueOnError = continueOnError;
  }

  toFailedResult(
    adapter: DestinationAdapter,
    error: unknown,
    duration: number
  ): DestinationResult {
    const message = error instanceof Error ? error.message : String(error);
    this.logger.forAdapter(adapter.name).error(`Execution failed: ${message}`);

    return {
      status: 'failed',
      adapter: adapter.name,
      duration,
      timestamp: Date.now(),
      error: message,
    };
  }

  shouldContinue(): boolean {
    return this.continueOnError;
  }
}
